import { render, staticRenderFns } from "./select-type.vue?vue&type=template&id=353794bf&scoped=true&lang=pug&"
import script from "./select-type.vue?vue&type=script&lang=js&"
export * from "./select-type.vue?vue&type=script&lang=js&"
import style0 from "./select-type.vue?vue&type=style&index=0&id=353794bf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353794bf",
  null
  
)

export default component.exports